import categories from '../utils/data/documentCategories.json';

export const useDocumentCategories = () => {
  return categories;
};
